document.addEventListener('DOMContentLoaded', () => {

  const floatingCall = document.querySelector('.floating-call');
  const footerArea = document.querySelector('.footer__main');

  if (!floatingCall) return;

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {

    // フッター付近では強制的に隠す
    if (footerArea) {

      const footerTop =
        footerArea.getBoundingClientRect().top;

      if (footerTop < window.innerHeight - 100) {
        floatingCall.classList.add('is-hidden');
        return;
      }

    }

    const currentScrollY = window.scrollY;

    // 上部では常に表示
    if (currentScrollY < 100) {
      floatingCall.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      return;
    }

    // 下へスクロール
    if (currentScrollY > lastScrollY) {
      floatingCall.classList.add('is-hidden');
    }

    // 上へスクロール
    else {
      floatingCall.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;

  });

});